import React from 'react';
import { useFlag } from '@wix/da-react-context/pkg/flags/hooks';
import GhostButton from '@wix/da-ds/pkg/Buttons/GhostButton';
import AssetIcon from './Icon';
import ActionBarItemWrapper from '../../ActionBar/_partials/items/ActionBarItemWrapper';
import classnames from 'classnames';
import { formatDollars } from '../../utils/formatting';
import { Url } from '@wix/da-url';
// eslint-disable-next-line @wix/da/scss-same-filename-as-module
import s from './Button.scss';
export const NonFunigbleButton = (props)=>{
    const { deviation , openBidModal , openManageModal , deviation: { extended: { digitalAsset: digitalAssetFull  } = {}  }  } = props;
    const { digitalAsset  } = deviation;
    const digital_assets = useFlag('digital_assets');
    if (!digital_assets) {
        return null;
    }
    // Bail no asset
    if (!digitalAsset || !digitalAsset.asset || !digitalAssetFull) {
        return null;
    }
    const { isOwner , canOffer , canPurchase , dollarPrice , subproductId  } = digitalAsset.asset;
    const { offers  } = digitalAssetFull;
    let hasOffer = false, madeOffer = false;
    if (offers) {
        hasOffer = !!offers.hasOffer;
        madeOffer = !!offers.madeOffer;
    }
    // Handle owner state
    if (isOwner) {
        return /*#__PURE__*/ React.createElement(ActionBarItemWrapper, {
            tooltip: hasOffer ? 'You have an offer!' : '',
            className: classnames(hasOffer && s['red-dot'])
        }, /*#__PURE__*/ React.createElement(GhostButton, {
            size: 'medium',
            variant: 'edit-purple',
            icon: AssetIcon,
            onClick: ()=>{
                openManageModal && openManageModal(deviation);
            }
        }, "Manage Collectible"));
    }
    // This user made an offer
    if (madeOffer) {
        return /*#__PURE__*/ React.createElement(ActionBarItemWrapper, {
            tooltip: 'You made an offer to buy this item!'
        }, /*#__PURE__*/ React.createElement(GhostButton, {
            size: 'medium',
            variant: 'edit-purple',
            icon: AssetIcon,
            onClick: ()=>{
                openManageModal && openManageModal(deviation);
            }
        }, "Manage Offer"));
    }
    // This user can make an offer
    if (canOffer) {
        return /*#__PURE__*/ React.createElement(ActionBarItemWrapper, {
            tooltip: 'You can offer to buy this collectible'
        }, /*#__PURE__*/ React.createElement(GhostButton, {
            size: 'medium',
            variant: 'main',
            icon: AssetIcon,
            onClick: ()=>{
                openBidModal && openBidModal(deviation);
            }
        }, "Make an Offer"));
    }
    // The item is listed and the user can buy
    if (canPurchase) {
        return /*#__PURE__*/ React.createElement(ActionBarItemWrapper, {
            tooltip: `You can own this collectible deviation!`
        }, /*#__PURE__*/ React.createElement(GhostButton, {
            size: 'medium',
            variant: 'main',
            icon: AssetIcon,
            onClick: ()=>{
                window.location.assign(Url.checkoutLink(subproductId || 0));
            }
        }, "Own for ", formatDollars(dollarPrice)));
    }
    return null;
};
NonFunigbleButton.displayName = 'DasNonFungibleButton';
export default NonFunigbleButton;
